import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthenticationService, RoutingService} from '../../services';
import {STATE_NAMES, EMAIL_PATTERN} from '../../common';
import {LoginModel} from '../../models/login.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginPageComponent {
  form: FormGroup;
  emailCtrl: FormControl;
  passwordCtrl: FormControl;
  isRememberMe = false;
  isSubmitting: boolean;
  notEmail: string;
  errorMessage: string;
  notPassword: string;

  constructor(private fb: FormBuilder,
              private routingService: RoutingService,
              private authenticationService: AuthenticationService) {
    this.emailCtrl = fb.control('', [Validators.required, Validators.pattern(EMAIL_PATTERN)]);
    this.passwordCtrl = fb.control('', [Validators.required]);
    this.form = fb.group({
      email: this.emailCtrl,
      password: this.passwordCtrl
    });
  }

  checkFilledInputs() {
    if (!this.passwordCtrl.value) {
      this.notPassword = 'Необходимо заполнить поле пароль';
      this.isSubmitting = true;
    }
    if (!this.emailCtrl.value) {
      this.notEmail = 'Необходимо заполнить поле E-mail';
      this.isSubmitting = true;
      return;
    }
    if (!this.emailCtrl.valid) {
      this.notEmail = 'E-mail не является правильным E-mail адресом';
      this.isSubmitting = true;
      return;
    }
  }

  onChanges() {
    this.form.valueChanges.subscribe(val => {
      if (val) {
        this.notEmail = null;
        this.isSubmitting = false;
        this.notPassword = null;
      }
    });
  }

  onSubmit() {
    try {
      this.errorMessage = null;
      if (this.form.valid && !this.isSubmitting) {
        this.isSubmitting = true;
        const model = new LoginModel({
          email: this.emailCtrl.value.toLowerCase(),
          password: this.passwordCtrl.value,
          rememberMe: this.isRememberMe
        });
        this.authenticationService.getToken(model).subscribe((res) => {
          if (res) {
            this.isSubmitting = false;
            const {role} = res;
            // const state = role.id === 1 ? STATE_NAMES.users : STATE_NAMES.travels;

            const state = STATE_NAMES.main;
            this.routingService.go(state);
          }
        }, (err) => {
          const defaultMessage = 'Невозможно войти с предоставленными учетными данными';
          this.errorMessage = err && err.error && err.error.message ? err.error.message : defaultMessage;
          this.isSubmitting = false;
          this.passwordCtrl.setValue(null);

        });
      } else {
        this.checkFilledInputs();
        this.onChanges();
      }
    } catch (e) {
      this.errorMessage = 'Невозможно войти с предоставленными учетными данными.';
      this.isSubmitting = false;
      this.passwordCtrl.setValue(null);
    }
  }
}
